module.exports = __webpack_public_path__ + "img/2e1eb4a.svg";